import {Injectable} from '@angular/core';
import olMap from 'ol/Map';
import {PointsService} from 'src/app/services/points.service';
import {MapService} from 'src/app/services/map.service';
import {HeaderControlService} from 'src/app/services/header-control.service';
import {LayerControlService} from 'src/app/services/layer-control.service';
import {ProjectService} from 'src/app/services/project.service';
import {CalculationsService} from 'src/app/services/calculations.service';
import {ConfigurationService} from 'src/app/services/configuration.service';

import { AirSpaceBoundary, AzimuthTool, CoordinatePoints, Navaids, Procedures, RangeRingTool, HorizonTool, StaticLayers, Trajectory, ProcedureGraph, dbBoundary, SAAMTrafficDensityLayer, FlightInspectionLayer, CrossSection, NavaidTextStyle, ProcedureAnalysisTool, coordinatePointsSelectedLayer, mapSearchHighlightLayer } from 'src/app/menu/view-menu/layersList';
import { InterferenceTest, Radar, Receivers, Devices} from 'src/app/menu/view-menu/layersList';
import {Collection, Feature, View} from 'ol';
import {Draw, Modify, Select} from 'ol/interaction';

import * as olProj from 'ol/proj';
import {TopLevelLayers} from 'src/app/menu/view-menu/top-level-layers';
import {ModalConfirmationService} from 'src/app/services/modal-confirmation.service';
import {ParentLayers} from 'src/app/menu/view-menu/parent-layer';
import {Layer, VectorLayerDMTR} from 'src/app/menu/view-menu/layer';
import {RouteSegmentsService} from 'src/app/services/route-segments.service';
import GeoJSON from 'ol/format/GeoJSON';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FeatureType, UserLayerTypes } from 'src/app/models/EnumTypes';
import { AreaService } from 'src/app/services/area.service';
import { ProcedureModel } from 'src/app/models/procedure';
import { ConfigurationModel } from 'src/app/models/configuration';
import { AreaModel } from 'src/app/models/area';
import { DistanceAzimuthService } from './distance-azimuth.service';
import { AzimuthToolService } from 'src/app/map/services/azimuth-tool.service'
import { RangeRingToolService } from './range-ring-tool.service';
import { HorizonToolService } from 'src/app/services/horizon-tool.service';
import { Fill, Icon, Stroke, Style, Text} from 'ol/style';
import { SAAMAirSpace } from 'src/app/models/saamAirSpace';
import CircleStyle from 'ol/style/Circle';
import {IdentifyToolService} from 'src/app/services/identify-tool.service';
import {TerrainHeightService} from './terrain-height.service';
import { TerrainAltitudeCutService } from 'src/app/services/terrain-altitude-cut.service';
import {UserLayer} from 'src/app/models/UserSettings';
import {CoordenateService} from 'src/app/services/coordenate.service';
import {UserSettingsService} from 'src/app/services/userSettings.service';
import VectorSource from 'ol/source/Vector';
import { SitingToolService } from 'src/app/services/siting-tool-service.service';
import {GritFeature} from "../../models/grit/grit.feature";
import {TabsService} from "../../services/tabsService";
import {InterferenceTestModel} from "../../models/grit/grit.interference-test-model";
import { Coordinate } from 'ol/coordinate';
import { cloneDeep } from 'lodash';
import {Geometry, MultiPoint} from "ol/geom";
import Point from "ol/geom/Point";
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { EventListenersOnMap } from 'src/app/utils/eventListenersOnMap';
import { SelectByFirComponent } from 'src/app/popup/select-by-fir/select-by-fir.component';
import { click } from 'ol/events/condition';
import { NavaidModel } from 'src/app/models/navaid';
@Injectable({
  providedIn: 'root'
})

export class GlobalSelectionControlService {

  skipClick: boolean = false;
  map: olMap;
  areasLayers: ParentLayers;
  airspaceboundaryLayers: ParentLayers;
  userLayer: ParentLayers;
  staticLayers: ParentLayers;
  navaidsLayers: ParentLayers;
  coordinatePointsLayers: ParentLayers;
  proceduresLayers: ParentLayers;
  proceduresLayersMenu: Layer[];
  routeSegmentsLayers: ParentLayers;
  annotationLayers: ParentLayers;
  calculationLayers: ParentLayers;
  azimuthToolLayers: ParentLayers;
  rangeRingToolLayers: ParentLayers;
  horizonToolLayers: ParentLayers;
  crossSectionLayers: ParentLayers;
  procedureAnalysisLayers: ParentLayers;
  trajectoriesLayers: ParentLayers;
  procedureGraphLayers: ParentLayers;
  dbBoundaryLayers: ParentLayers;
  saamTrafficDensityLayer: ParentLayers;
  flightInspectionLayer: ParentLayers;
  processingToolLayer: ParentLayers;
  coordinatePointsSelectedLayer: ParentLayers;
  mapSearchHighlightLayer: ParentLayers;
  active: boolean = false;
  modify: Modify;

  //#region GRIT
  deviceLayer: ParentLayers;
  interferenceTestLayer : ParentLayers;
  radarLayer : ParentLayers;
  //endregion

  constructor(public pointsService: PointsService, public mapService: MapService, public headerService: HeaderControlService, public layerService: LayerControlService,
    public calculationsService: CalculationsService, public projectService: ProjectService,
    public routeSegmentService: RouteSegmentsService, public configurationService: ConfigurationService,
    private modalConfirmationService: ModalConfirmationService, private areaService: AreaService, private distanceService: DistanceAzimuthService, private azimuthToolService: AzimuthToolService, private rangeRingToolService: RangeRingToolService,
    private identifyToolService: IdentifyToolService, private terrainHeightService: TerrainHeightService,
    private rcsControl: CoordenateService,
    private userSettingsService: UserSettingsService,
    private sitingToolService: SitingToolService, private terrainAltitudeCutService: TerrainAltitudeCutService

  ) {
    this.map = mapService.getMap('map');
    this.userLayer = new ParentLayers(true, "User Layers", [new TopLevelLayers(true, "User Layers", [], this.map, this.modalConfirmationService)]);
    this.staticLayers = new ParentLayers(false, "Static Layers", [new TopLevelLayers(false, "Static Layers", StaticLayers, this.map, this.modalConfirmationService)]);
    this.navaidsLayers = new ParentLayers(true, "Navaids", [new TopLevelLayers(true, "Navaids", Navaids, this.map, this.modalConfirmationService)]);
    this.coordinatePointsLayers = new ParentLayers(true, "Coordinate Points", [new TopLevelLayers(true, "Coordinate Points", CoordinatePoints, this.map, this.modalConfirmationService)]);
    this.routeSegmentsLayers = new ParentLayers(true, "Route Segments", []);
    this.routeSegmentService.setRouteSegmentLayer(this.routeSegmentsLayers);
    this.proceduresLayers = new ParentLayers(false, "Procedures", [new TopLevelLayers(true, "Procedures", Procedures, this.map, this.modalConfirmationService)]);
    this.proceduresLayersMenu = this.proceduresLayers.childLayers[0].layers.filter(layer => !layer.name.includes('ASSESSMENT'))
    Procedures.forEach(layer => {
      layer.olLayer.setZIndex(3);
    })
    // coordinatePointsSelectedLayer.olLayer.setZIndex(TopLevelLayers.DEFAULT_Z_INDEX);
    // coordinatePointsSelectedLayer.olLayer.setVisible(true);
    // this.mapService.getMaps().addLayer(coordinatePointsSelectedLayer.olLayer);

    this.airspaceboundaryLayers = new ParentLayers(false, "Air Space Boundaries", [new TopLevelLayers(true, "Air Space Boundaries", AirSpaceBoundary, this.map, this.modalConfirmationService)]);
    this.trajectoriesLayers = new ParentLayers(false, "Trajectories", [new TopLevelLayers(true, "Trajectories", Trajectory, this.map, this.modalConfirmationService)]);
    this.annotationLayers = new ParentLayers(true, "Annotations", []);
    this.calculationLayers = new ParentLayers(true, "Calculations", []);
    this.areasLayers = new ParentLayers(true, "Areas", []);
    this.azimuthToolLayers = new ParentLayers(false, "Azimuth Tool Layer", [new TopLevelLayers(true, "Azimuth Tool Layer", AzimuthTool, this.map, this.modalConfirmationService)]);
    this.rangeRingToolLayers = new ParentLayers(false, "Range Ring Tool Layer", [new TopLevelLayers(true, "Range Ring Tool Layer", RangeRingTool, this.map, this.modalConfirmationService)]);
    let horizonTopLevelLayer: TopLevelLayers = new TopLevelLayers(true, "Horizon Tool Layer", HorizonTool, this.map, this.modalConfirmationService)
    horizonTopLevelLayer.layers[0].expanded = false;
    let procedureAnalysisTopLevelLayer: TopLevelLayers = new TopLevelLayers(true, "Procedure Analysis Layer", ProcedureAnalysisTool, this.map, this.modalConfirmationService)
    procedureAnalysisTopLevelLayer.layers[0].expanded = false;
    this.horizonToolLayers = new ParentLayers(false, "Horizon Tool Layer", [horizonTopLevelLayer]);
    let crossSectionLevelLayer: TopLevelLayers = new TopLevelLayers(true, "Cross Section Layer", CrossSection, this.map, this.modalConfirmationService);
    this.procedureAnalysisLayers = new ParentLayers(false, "Procedure Analysis Layer", [procedureAnalysisTopLevelLayer]);
    crossSectionLevelLayer.layers[0].expanded = false;
    this.crossSectionLayers = new ParentLayers(false, "Cross Section Layer", [crossSectionLevelLayer]);
    this.procedureGraphLayers = new ParentLayers(false, "Procedure Graph Layer", [new TopLevelLayers(true, "Procedure Graph Layer", ProcedureGraph, this.map, this.modalConfirmationService)]);
    this.dbBoundaryLayers = new ParentLayers(false, "8db Boundary Layer", [new TopLevelLayers(true, "8db Boundary Layer", dbBoundary, this.map, this.modalConfirmationService)]);
    this.saamTrafficDensityLayer = new ParentLayers(false, "SAAM Traffic Densities", [new TopLevelLayers(true, "SAAM Traffic Density", SAAMTrafficDensityLayer, this.map, this.modalConfirmationService)]);
    this.flightInspectionLayer = new ParentLayers(false, "Flight Inspection", [], true);
    this.processingToolLayer = new ParentLayers(false, "FI Processing Tool", [], true);
    this.coordinatePointsSelectedLayer = new ParentLayers(true, "coordinatePointsSelectedLayer", [new TopLevelLayers(true, "coordinatePointsSelectedLayer", [coordinatePointsSelectedLayer], this.map, this.modalConfirmationService)]);
    this.mapSearchHighlightLayer = new ParentLayers(true,"mapSearchHighlightLayer", [new TopLevelLayers(true, "mapSearchHighlightLayer", [mapSearchHighlightLayer], this.map, this.modalConfirmationService)]);

    //#region GRIT
    this.deviceLayer = new ParentLayers(true, FeatureType.Device,
      [new TopLevelLayers(true, FeatureType.Device, Devices, this.map, this.modalConfirmationService)]);
    this.pointsService.deviceLayer = this.deviceLayer;

    this.interferenceTestLayer = new ParentLayers(true, FeatureType.InterferenceTest,
      [new TopLevelLayers(true, FeatureType.InterferenceTest, InterferenceTest, this.map, this.modalConfirmationService),]);
    this.pointsService.interferenceTestLayer = this.interferenceTestLayer;

    this.radarLayer = new ParentLayers(true, FeatureType.Radar,
      [new TopLevelLayers(true, FeatureType.Radar, Radar, this.map, this.modalConfirmationService),]);
    this.pointsService.radarLayer = this.radarLayer;
    //endregion


    this.pointsService.setNavaidsLayer(this.navaidsLayers);
    this.pointsService.setCoordinatePointsLayer(this.coordinatePointsLayers);
    this.pointsService.setCalculationsLayer(this.calculationLayers);
    this.pointsService.setAreasLayer(this.areasLayers);
    this.pointsService.setAnnotationLayer(this.annotationLayers);
    this.calculationsService.setCalculationsLayer(this.calculationLayers);
    this.pointsService.setProceduresLayer(this.proceduresLayers);
    this.pointsService.setAirSpaceBoundariesLayer(this.airspaceboundaryLayers);
    this.pointsService.setAzimuthToolLayer(this.azimuthToolLayers);
    this.pointsService.setRangeRingToolLayer(this.rangeRingToolLayers);
    this.pointsService.setHorizontalToolLayer(this.horizonToolLayers);
    this.pointsService.setCrossSectionLayer(this.crossSectionLayers);
    this.pointsService.setProcedureAnalysisLayer(this.procedureAnalysisLayers);
    this.pointsService.setTrajectoriesLayer(this.trajectoriesLayers);
    this.pointsService.setProcedureGraphLayer(this.procedureGraphLayers);
    this.pointsService.set8dbBoundaryLayer(this.dbBoundaryLayers)
    this.pointsService.setStaticLayer(this.staticLayers);
    this.pointsService.setSAAMTrafficLayer(this.saamTrafficDensityLayer);
    this.pointsService.setFlightInspectionLayer(this.flightInspectionLayer);
    this.pointsService.setProcessingToolLayer(this.processingToolLayer);
    this.pointsService.setUserLayer(this.userLayer);

    this.mapService.setLayers([
      this.navaidsLayers,
      this.coordinatePointsLayers,
      this.proceduresLayers,
      this.routeSegmentsLayers,
      this.airspaceboundaryLayers,
      this.trajectoriesLayers,
      this.staticLayers,
      this.saamTrafficDensityLayer,
      this.flightInspectionLayer,
      this.processingToolLayer,
      //#region GRIT
      this.deviceLayer,
      this.interferenceTestLayer,
      this.radarLayer,
      //endregion
    ]);
    this.setPointerAll();
  }

  addUserLayerToMap() {
    this.userSettingsService.userSettings.userLayers
      .forEach((userLayer: UserLayer) => {
        if (userLayer.type == UserLayerTypes.SHAPEFILE) {
          const vectorSource = new VectorSource({
            features: new GeoJSON().readFeatures(userLayer.data),
          });
          const vectorLayer = new VectorLayerDMTR({
            source: vectorSource,
          });
          let layer: Layer = {
            id: JSON.stringify(userLayer.id), name: userLayer.name,
            visible: true, image: "",
            olLayer: vectorLayer
          }
          this.userLayer.childLayers[0].addLayers([layer]);
        }
      })
  }

  changeExtent() {

    let foundDefault: boolean = false;
    this.areaService.areas.forEach(obtainedArea => {
      let area: AreaModel = AreaModel.map(obtainedArea);
      this.areaService.areas.set(area.id, area);
      if (area.defaultArea && this.configurationService.currentConfiguration.display.startDefaultArea) {
        this.areaService.openArea(area);
        foundDefault = true;
      }
    });

    if (!foundDefault) {
      this.mapService.reprojectMap(this.configurationService.coordenateService.activeRCS.epsg);
    }

  }

  layersTrigger(): void {
    this.layerService.active = !this.layerService.active;
    if (document.getElementsByClassName('header__trigger')[0].classList.contains("active")) {
      document.getElementsByClassName('header__tail')[0].classList.remove("active");
      document.getElementsByClassName('header__trigger')[0].classList.remove("active");
      document.getElementsByClassName('header__container')[0].classList.remove("active");
      this.headerService.active = false;
    }
  }

  setPointerAll(): void {
    this.setPointer([
      this.navaidsLayers,
      this.coordinatePointsLayers,
      this.proceduresLayers,
      this.routeSegmentsLayers,
      this.airspaceboundaryLayers,
      this.trajectoriesLayers,
      this.staticLayers,
      this.saamTrafficDensityLayer,
      this.flightInspectionLayer,
      this.processingToolLayer,
      //#region GRIT
      this.deviceLayer,
      // this.radarLayer,
      this.interferenceTestLayer,
      //endregion
      this.coordinatePointsSelectedLayer
    ]);
    this.distanceService.clearListeners();

  }

  isPointerAll(): boolean {
    return this.coordinatePointsLayers.layersSelector.pointer && this.navaidsLayers.layersSelector.pointer;
  }

  /**
   * Select features by single click
   * @param layers layers on which the selection is made
   * @param layerSelector the selector to mark
   */
  setPointer(layers: ParentLayers[]) {
    //#region GRIT
    let unselectTab = !layers.includes(this.interferenceTestLayer) || this.pointsService.getSelectedFeaturesOfType(FeatureType.InterferenceTest).length == 0
    // this.clearAllSelected(unselectTab);
    //endregion

    // this.mapService.clearSelections();
    this.clearRelevantSelectedTools();
    this.mapService.clearSelectionsExcept();
    layers.forEach((element) => element.layersSelector.pointer = true)
    // let layersArr = layers.map(layers => layers.childLayers.map(child => child.layers).reduce((acc,val)=>acc.concat(val))
    // .map(layer => layer.olLayer)).reduce((accumulator, value) => accumulator.concat(value));
    let layersArr2 = [];
    layers.forEach(parentLayer => {
      parentLayer.childLayers.forEach(chlid => {
        chlid.layers.forEach(layer => layersArr2.push(layer.olLayer));
      });
    })

    this.mapService.select = new Select({
      style: null,
      //train wreck anti pattern....
      layers: layersArr2,
      hitTolerance: 5,
      filter: (feature) => !feature.get('mapSearchHighlight'),

    })

    var thisObject = this;
    this.mapService.select.on('select', function (event) {
      if (event.deselected.length > 0) {

        for (let feature of event.deselected) {
          if (feature.getGeometry() instanceof MultiPoint) {
            thisObject.pointsService.clearSelectedCoordinatePoints(false);
          } else if (feature.get("featureType") == FeatureType.CoordinatePoint) {
            const index: number = feature.get(CoordinatePointModel.INDEX_FEATURE_PROPERTY);
            const layerId: string = feature.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY);
            const published: boolean = feature.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY);
            if (index && layerId) {
              thisObject.pointsService.removeSelectedFeatureCoordinatePointFromLayer(index, layerId, published);
            }
          } else {
            thisObject.removeSelectedFeature(feature);
          }
        }
      }

      if (event.selected.length > 0) {
        // Check if Shift key is pressed
        // const shiftPressed = event.mapBrowserEvent.originalEvent.shiftKey;

        // if (!shiftPressed) {
        //   thisObject.pointsService.clearSelectedCoordinatePoints();
        // }

        if (event.selected[0].getGeometry() instanceof MultiPoint) {

          coordinatePointsSelectedLayer.olLayer.setVisible(true);

          const selectedCoordinate: Coordinate = (event.selected[0].getGeometry() as MultiPoint).getClosestPoint(event.mapBrowserEvent.coordinate);
          const index = (event.selected[0].getGeometry() as MultiPoint).getCoordinates()
            .findIndex(coordinate => coordinate[0] == selectedCoordinate[0] && coordinate[1] == selectedCoordinate[1]);
          const layerId = event.selected[0].get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY);

          const layer = thisObject.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id == layerId)

          thisObject.setSelectedFeatureCoordinatePoint(selectedCoordinate, index, layer, event.selected[0].get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY));
          thisObject.mapService.clearCoordinatePointsSelections();
        }
        else {
          const layer = thisObject.mapService.select.getLayer(event.selected[0]) as unknown as VectorLayerDMTR;
          thisObject.setSelectedFeature(layer, event.selected[0]);

          //#region GRIT
          if (event.selected[0].get("featureType") === FeatureType.InterferenceTest){
            thisObject.mapService.select.getFeatures().remove(event.selected[0]);
            thisObject.pointsService.tabsService.openInterferenceTestTab((event.selected[0] as GritFeature<InterferenceTestModel>).entity)
          }
          //endregion
        }

      }
    });
    this.rehydratePointerSelectionInto(this.mapService.select)
    this.map.addInteraction(this.mapService.select);
  }

  private rehydratePointerSelectionInto(select: Select) {
    const coll = select.getFeatures();

    const alreadySelected = this.pointsService.getSelectedFeatures?.() ?? [];
    const arr = coll.getArray();
    alreadySelected.forEach(f => {
      if (arr.indexOf(f) === -1) coll.push(f);
    });

    const src = coordinatePointsSelectedLayer.olLayer?.getSource?.();
    if (src) {
      src.getFeatures().forEach(f => {
        if (arr.indexOf(f) === -1) coll.push(f);
      });
    }
  }

  setBoxAll(): void {
    this.setBoxSelection([
      this.navaidsLayers,
      this.coordinatePointsLayers,
      this.proceduresLayers,
      this.routeSegmentsLayers,
      this.airspaceboundaryLayers,
      this.trajectoriesLayers,
      this.staticLayers,
      this.saamTrafficDensityLayer,
      this.flightInspectionLayer,
      this.processingToolLayer,
      //#region GRIT
      this.deviceLayer,
      // this.radarLayer,
      //endregion
    ]);
  }
  isBoxAll(): boolean {
    return this.coordinatePointsLayers.layersSelector.polygon && this.navaidsLayers.layersSelector.polygon;
  }

  /**
   * Sets selection as a polygon
   * @param layers
   * @param layerSelector
   */
  setBoxSelection(layers: ParentLayers[])
  {
    // this.mapService.clearSelections();
    // this.clearAllSelected();
    this.clearRelevantSelectedTools();
    this.mapService.clearSelectionsExcept();
    layers.forEach((element) => element.layersSelector.polygon = true);

    this.mapService.draw = new Draw({
      source: this.mapService.selectionSource,
      type: "Polygon",
    });


    this.map.addInteraction(this.mapService.draw);

    this.setSelection(layers);
  }


  setCircleAll(): void {
    this.setCircleSelection([
      this.navaidsLayers,
      this.coordinatePointsLayers,
      this.proceduresLayers,
      this.routeSegmentsLayers,
      this.airspaceboundaryLayers,
      this.trajectoriesLayers,
      this.staticLayers,
      this.saamTrafficDensityLayer,
      this.flightInspectionLayer,
      this.processingToolLayer,
      //#region GRIT
      this.deviceLayer,
      // this.radarLayer,
      //endregion
    ]);
  }

  isCircleAll(): boolean {
    return this.coordinatePointsLayers.layersSelector.circle && this.navaidsLayers.layersSelector.circle;
  }

  /**
   * Sets selection as a Circle
   * @param layers
   */
  setCircleSelection(layers: ParentLayers[],) {
    // this.mapService.clearSelections();
    // this.clearAllSelected();
    this.clearRelevantSelectedTools();
    this.mapService.clearSelectionsExcept();
    layers.forEach((element) => element.layersSelector.circle = true);

    this.mapService.draw = new Draw({
      source: this.mapService.selectionSource,
      type: "Circle",
    });

    this.map.addInteraction(this.mapService.draw);

    this.setSelection(layers);

  }

  setSelection(layers: ParentLayers[]): void {

    // this.pointsService.clearSelectedFeatures();

    //bring the variables to scope
    var me = this;

    this.mapService.draw.on('drawend', function (endEvent) {
      // features that intersect the geometry are added to the
      // collection of selected features
      this.skipClick = true;
      var geometry: Geometry = endEvent.feature.getGeometry();
      var extent = geometry.getExtent();
      for (var parentLayer of layers) {
        for (var child of parentLayer.childLayers) {
          child.layers.forEach(function (layer) {
            if (layer.visible) {
              layer.olLayer.getSource().forEachFeatureIntersectingExtent(extent, function (feature) {
                if (geometry.intersectsExtent(feature.getGeometry().getExtent())) {
                  if (feature.getGeometry() instanceof MultiPoint) {
                    (feature.getGeometry() as MultiPoint).getCoordinates()
                      .forEach((coordinate, index) => {
                        if (geometry.intersectsCoordinate(coordinate)) {
                          me.setSelectedFeatureCoordinatePoint(coordinate, index, layer, feature.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY));
                        }
                      });
                  }
                  else {
                    me.setSelectedFeature(layer.olLayer, feature);
                  }
                }
              });
            }
          });
        }
      }

      setTimeout(() => { this.skipClick = false; }, 251);

    }.bind(this));

  }

  setSelectedCoordinatePointModel(point: CoordinatePointModel): Feature {
    let id: string;
    if (point.id) {
      id = point.id.toString();
    } else if (point.uuid) {
      id = point.uuid
    } else {
      return;
    }
    const index: number = this.pointsService.getCoordinatePointFeatureMapById(id)[0];
    return this.setSelectedFeatureCoordinatePoint(olProj.fromLonLat([point.longitude, point.latitude], this.mapService.getMaps().getView().getProjection()), index,
      this.pointsService.getLayerFromCoordPointType(point.type), !point.userdefined);
  }

  setSelectedCoordinatePointFeature(point: Feature): Feature {
    let id: string;
    if (point.get("id")) {
      id = point.get("id").toString();
    } else if (point.get("uuid")) {
      id = point.get("uuid")
    } else {
      return;
    }
    const index: number = this.pointsService.getCoordinatePointFeatureMapById(id)[0];
    return this.setSelectedFeatureCoordinatePoint(olProj.fromLonLat([point.get("longitude"), point.get("latitude")],
      this.mapService.getMaps().getView().getProjection()), index,
      this.pointsService.getLayerFromCoordPointType(point.get("type")), !point.get("userdefined"));
  }


  setSelectedFeatureCoordinatePoint(coordinate: Coordinate, index: number, layer: Layer, published: boolean): Feature {
    const source = coordinatePointsSelectedLayer.olLayer.getSource();
    coordinatePointsSelectedLayer.olLayer.setVisible(true);
    let indexes: number[] = this.pointsService.layerIdToCPIndexSelected.get(JSON.stringify([layer.id, published]));
    if (indexes == null) {
      indexes = [];
      this.pointsService.layerIdToCPIndexSelected.set(JSON.stringify([layer.id, published]), indexes);
    }
    if (indexes.includes(index)) { // feature is already selected. Prevents multiple selections on the same feature
      const feature = this.pointsService.getCoordinatePointFeatureMapFromLayer(layer.id, published).get(index);
      this.pointsService.setGeometryForCoordinatePointFeature(feature);
      return feature;
    }
    indexes.push(index);
    let feature = new Feature(new Point(coordinate))
    feature.set(CoordinatePointModel.INDEX_FEATURE_PROPERTY, index);
    feature.set(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY, layer.id);
    feature.set(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY, published);
    feature.set("featureType", FeatureType.CoordinatePoint);
    feature.setStyle(layer.olLayer.getStyleSelected());
    source.addFeature(feature);
    this.mapService.select.getFeatures().push(feature);
    return feature;
  }

  setSelectedFeature(layer: VectorLayerDMTR, feature: Feature, customStyle?: any): void {
    if (customStyle) {
      feature.setStyle(customStyle);
    } else {
      feature.setStyle(layer.getStyleSelected());
    }
    if (feature.getProperties().featureType == FeatureType.Navaid) {
      const currentStyle: Style = feature.getStyle() as Style;
      const newStyleFunction = function () {
        const zoom = this.mapService.getMap('map').getView().getZoom();
        let text = feature.get('navaidid');
        if (!this.pointsService.showNavaidsIdOnMap || zoom < MapService.SHOW_TEXT_ON_MAP_ZOOM_LIMIT) {
          text = "";
        }
        const textStyle = NavaidTextStyle
        textStyle.setText(text);
        if (customStyle) {
          currentStyle[0].setText(textStyle);
        } else {
          currentStyle.setText(textStyle);
        }
        return currentStyle;
      }.bind(this)
      feature.setStyle(newStyleFunction);
      // layer.getSource().addFeature(feature2);
    }
    this.pointsService.addSelectedFeature(feature);
    if (feature.getProperties().featureType == FeatureType.Annotation) {
      this.modify = new Modify({ features: new Collection([feature]) });
      this.map.addInteraction(this.modify);
      var context = this;
      this.modify.on('modifyend', function (endEvent) {
        var newSource = new GeoJSON().writeFeatures(endEvent.features.getArray(), {
          dataProjection: 'CRS:84',
          featureProjection: context.pointsService.rcsControl.activeRCS.isactive ? context.pointsService.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
        });
        context.pointsService.annotations.forEach(el => {
          if (el.name == feature.get("name")) {
            el.source = newSource;
            context.pointsService.saveAnnotation(el).subscribe((result) => {
              if (!result) {
                this.modalService.showMesssageModal('Error', 'An error occured on modifying the annotation');
              }
            },
              (error) => {
                if (error && error.status == 401) {
                  this.modalService.showMesssageModal(
                    'Error',
                    'Default Project is not editable.'
                  )
                  return;
                }
                this.modalService.showMesssageModal("Error", "An error occured on modifying the annotation");
              });
          }
        });
      });
    }
    else if (feature.getProperties().featureType == FeatureType.Procedure) {
      const currentStyle: Style = feature.getStyle() as Style;
      currentStyle.setZIndex(9999);

      let procedure: ProcedureModel = this.pointsService.transformFeatureInProcedure(feature);
      if (procedure.navaids.length > 0) {
        this.modalConfirmationService.showMesssageConfirmationModal("Select Procedure NavAids", "Do you want to select Procedure associated NavAids?", "Yes", "No", () => {
          procedure.navaids.forEach(navaid => {
            let feature: Feature = this.pointsService.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaid.navaidtype.toLowerCase())
              .olLayer.getSource().getFeatureById(navaid.id);
            let layer: VectorLayerDMTR = this.pointsService.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaid.navaidtype.toLowerCase())
              .olLayer;
            this.setSelectedFeature(layer, feature);
          });
        });

      }
    }
    else if (feature.getProperties().featureType == FeatureType.SAAMTraffic) {
      let saamFeatures: Feature[] = [];
      this.pointsService.saamTrafficDensityLayer.childLayers[0].layers
        .forEach(layer => {
          saamFeatures.push(...layer.olLayer.getSource().getFeatures().filter(feat => feat.get('id') == feature.get('id')));
        });
      saamFeatures.forEach(feature => { feature.setStyle(layer.getStyleSelected()); this.pointsService.addSelectedFeature(feature) });
    }
    else if (feature.getProperties().featureType == FeatureType.FlightInspection) {
      let flightInspectionLayer: TopLevelLayers = this.pointsService.flightInspectionLayer.childLayers.find(layer => layer.flightInspectionId == feature.get('id'));
      if (!flightInspectionLayer.layerSelected) {
        flightInspectionLayer.layerSelected = true;
        flightInspectionLayer
          .layers[0].olLayer.getSource().getFeatures()
          .forEach(feature => { feature.setStyle(layer.getStyleSelected()); this.pointsService.addSelectedFeature(feature); });
      }

      /*
      this.pointsService.flightInspectionLayer.childLayers[0].layers[0]
      .olLayer.getSource().getFeatures().filter(feat => feat.get('name') == feature.get('name'))
      .forEach(feature => {feature.setStyle(layer.getStyleSelected());this.pointsService.addSelectedFeature(feature)} );
      */
    }
    else if (feature.getProperties().featureType == FeatureType.ProcessingTool) {
      let processingToolLayer: TopLevelLayers = this.pointsService.processingToolLayer.childLayers.find(layer => layer.flightInspectionId == feature.get('id'));
      if (!processingToolLayer.layerSelected) {
        processingToolLayer.layerSelected = true;
        processingToolLayer
          .layers[0].olLayer.getSource().getFeatures()
          .forEach(feature => { feature.setStyle(layer.getStyleSelected()); this.pointsService.addSelectedFeature(feature); });
      }

      /*
      this.pointsService.flightInspectionLayer.childLayers[0].layers[0]
      .olLayer.getSource().getFeatures().filter(feat => feat.get('name') == feature.get('name'))
      .forEach(feature => {feature.setStyle(layer.getStyleSelected());this.pointsService.addSelectedFeature(feature)} );
      */
    } else if (feature.getProperties().featureType == FeatureType.CoordinatePoint) {

      const currentStyle: Style = feature.getStyle() as Style;
      currentStyle.setZIndex(9999);
    }

  }

  removeSelectedFeatureCoordinatePoint(coordinate: number[], multiPointFeature: Feature) {
    const index = (multiPointFeature.getGeometry() as MultiPoint).getCoordinates()
      .findIndex(coordinate2 => coordinate2[0] == coordinate[0] && coordinate2[1] == coordinate[1]);
    const layerId = multiPointFeature.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY);

    const published = multiPointFeature.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY);

    this.pointsService.removeSelectedFeatureCoordinatePointFromLayer(index, layerId, published);
  }




  removeSelectedFeature(feature: Feature, procedureAssessment?: boolean): void {
    if (!feature || feature.getGeometry() instanceof MultiPoint) {
      return;
    }
    if (feature.getProperties().featureType == FeatureType.CoordinatePoint) {
      if (!procedureAssessment) {
        const index: number = feature.get(CoordinatePointModel.INDEX_FEATURE_PROPERTY);
        const layerId: string = feature.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY);
        const published: boolean = feature.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY);
        if (index && layerId) {
          this.pointsService.removeSelectedFeatureCoordinatePointFromLayer(index, layerId, published);
        }
      } else { // procedure assessment
        let layer: Layer;
        if (feature.getProperties().type == 'AIRSPACE_BOUNDARY_VERTEX') {
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id == 'airspace_vertex');
        }
        else {
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id == feature.getProperties().type.toLowerCase());
        }

        const color = this.pointsService.getColorOfType('Coordinate Points', layer.id, feature.get("userdefined"));
        const layerStyle: Style = (layer.olLayer.getStyle()) as Style;
        const iconSelected: Icon = (layerStyle.getImage() as Icon);
        const style = new Style({
          image: new Icon({
            scale: layerStyle.getImage().getScale(),
            color: color ? color : feature.getProperties().originalColor,
            src: iconSelected.getSrc(),
          }),
        });
        layer.olLayer.getSource().removeFeature(feature);
        feature.setStyle(style);
        layer.olLayer.getSource().addFeature(feature);
      }

      return;
    }

    if (feature.getProperties().featureType != FeatureType.AirSpaceBoundary && feature.getProperties().featureType != FeatureType.CoordinatePoint && feature.getProperties().featureType != FeatureType.Navaid && feature.getProperties().featureType != FeatureType.SAAMTraffic && feature.getProperties().featureType != FeatureType.FlightInspection && feature.getProperties().featureType != FeatureType.ProcessingTool)
      feature.setStyle(null);
    else if (feature.getProperties().featureType == FeatureType.SAAMTraffic) {
      let style = new Style({
        fill: new Fill({ color: feature.getProperties().originalColor }),
        stroke: new Stroke({ color: 'black', width: 1 })
      })
      feature.setStyle(style);
    }
    else if (feature.getProperties().featureType == FeatureType.FlightInspection) {
      feature.setStyle(feature.getProperties().originalStyle);
      let flightInspectionLayer: TopLevelLayers = this.pointsService.flightInspectionLayer.childLayers.find(layer => layer.flightInspectionId == feature.get('id'));

      if (flightInspectionLayer != null && flightInspectionLayer.layerSelected) {
        flightInspectionLayer.layerSelected = false;
        flightInspectionLayer
          .layers[0].olLayer.getSource().getFeatures()
          .forEach(feature => { feature.setStyle(feature.getProperties().originalStyle); this.pointsService.addSelectedFeature(feature); });
      }

    }
    else if (feature.getProperties().featureType == FeatureType.ProcessingTool) {
      feature.setStyle(feature.getProperties().originalStyle);
      let processingToolLayer: TopLevelLayers = this.pointsService.processingToolLayer.childLayers.find(layer => layer.flightInspectionId == feature.get('id'));

      if (processingToolLayer != null && processingToolLayer.layerSelected) {
        processingToolLayer.layerSelected = false;
        processingToolLayer
          .layers[0].olLayer.getSource().getFeatures()
          .forEach(feature => { feature.setStyle(feature.getProperties().originalStyle); this.pointsService.addSelectedFeature(feature); });
      }

    }
    else if (feature.getProperties().featureType == FeatureType.Navaid) {
      let layer: Layer = this.navaidsLayers.childLayers[0].layers
        .find((element) => element.id == feature.getProperties().navaidtype.toLowerCase());

      if (layer != null) {
        let layerStyle: Style = (layer.olLayer.getStyle()) as Style;
        let iconSelected: Icon = (layerStyle.getImage() as Icon);
        const style = function () {
          const zoom = this.mapService.getMap('map').getView().getZoom();
          let text = feature.get('navaidid');
          if (!this.pointsService.showNavaidsIdOnMap || zoom < MapService.SHOW_TEXT_ON_MAP_ZOOM_LIMIT) {
            text = "";
          }
          const textStyle = NavaidTextStyle;
          textStyle.setText(text);
          return [
            new Style({
              image: new Icon({
                scale: layerStyle.getImage().getScale(),
                color: feature.getProperties().originalColor,
                src: iconSelected.getSrc(),
              }),
              text: textStyle
            })
          ];
        }.bind(this);
        layer.olLayer.getSource().removeFeature(feature);
        feature.setStyle(style);
        layer.olLayer.getSource().addFeature(feature);
      }

    }
    else if (feature.getProperties().featureType == FeatureType.AirSpaceBoundary) {
      let style: Style = new Style({
        fill: new Fill({ color: feature.getProperties().originalColor }),
        stroke: new Stroke({ color: feature.getProperties().originalColor, width: 2 })
      });
      feature.setStyle(style)
    }
    this.pointsService.removeSelectedFeature(feature);
    if (this.modify != null) {
      this.map.removeInteraction(this.modify);
      this.modify = null;
    }

  }

  clearAllSelectedTools(): void {
    //#region GRIT
    this.pointsService.tabsService?.unselectTab(TabsService.INTERFERENCE_TEST);
    //endregion

    this.mapService.clearSelections();
    this.sitingToolService.clearSitingToolDraw();

    this.pointsService.getSelectedFeatures().forEach(feature => {
      this.removeSelectedFeature(feature);
    });
    this.pointsService.clearSelectedCoordinatePoints(false);

    this.distanceService.clearMeasures();
    this.azimuthToolService.clearLayer();
    this.rangeRingToolService.clearLayer();
    this.rangeRingToolService.clearListeners();
    this.terrainHeightService.clearListeners();
    this.terrainAltitudeCutService.clearListeners();

    EventListenersOnMap.RemoveEventListener(IdentifyToolService.EVENT_ON_MAP_LABEL, true);
    EventListenersOnMap.RemoveEventListener(SelectByFirComponent.EVENT_ON_MAP_LABEL, true);
    EventListenersOnMap.RemoveEventListener(TerrainHeightService.EVENT_ON_MAP_LABEL, true);
    EventListenersOnMap.RemoveEventListener(TerrainHeightService.EVENT_ON_MAP_LABEL2, false);
    EventListenersOnMap.RemoveEventListener(DistanceAzimuthService.EVENT_ON_MAP_LABEL, true);
    EventListenersOnMap.RemoveEventListener(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL, true);


  }

  clearRelevantSelectedTools(): void {
    this.distanceService.clearMeasures();
    this.azimuthToolService.clearLayer();
    this.rangeRingToolService.clearLayer();
    this.rangeRingToolService.clearListeners();
    this.terrainHeightService.clearListeners();
    this.terrainAltitudeCutService.clearListeners();

    EventListenersOnMap.RemoveEventListener(IdentifyToolService.EVENT_ON_MAP_LABEL, true);
    EventListenersOnMap.RemoveEventListener(SelectByFirComponent.EVENT_ON_MAP_LABEL, true);
    EventListenersOnMap.RemoveEventListener(TerrainHeightService.EVENT_ON_MAP_LABEL, true);
    EventListenersOnMap.RemoveEventListener(TerrainHeightService.EVENT_ON_MAP_LABEL2, false);
    EventListenersOnMap.RemoveEventListener(DistanceAzimuthService.EVENT_ON_MAP_LABEL, true);
    EventListenersOnMap.RemoveEventListener(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL, true);


  }

  clearAllSelected(unselectTab:boolean = true): void {
    //#region GRIT
    if (unselectTab) this.pointsService.tabsService?.unselectTab(TabsService.INTERFERENCE_TEST);
    //endregion

    this.mapService.clearSelections();
    this.pointsService.clearSelectedCoordinatePoints(false);


    this.pointsService.getSelectedFeatures()?.forEach((feature : GritFeature<any>) => {
      if (!unselectTab && feature.featureType == FeatureType.InterferenceTest) return;

      this.removeSelectedFeature(feature);
    });
  }

  clearAllSelectedExceptRouteSegment(): void {
    //#region GRIT
    this.pointsService.tabsService?.unselectTab(TabsService.INTERFERENCE_TEST);
    //endregion

    this.mapService.clearSelections();

    this.pointsService.getSelectedFeatures().forEach(feature => {
      if (feature.getProperties().featureType != 3) {
        this.removeSelectedFeature(feature);
      }
    });
  }
  selectNavaidOnMap(feat: Feature, layer: VectorLayerDMTR) {

    const coChannelStyle = new Style({
      fill: new Fill({
        color: 'rgba(255, 0, 0, 1)',
      }),
      image: new CircleStyle({
        radius: 2,
        stroke: new Stroke({
          color: 'rgba(255, 0, 0, 1)',
        }),
        fill: new Fill({
          color: 'rgba(255, 0, 0, 1)',
        }),
      }),
    })

    this.setSelectedFeature(layer, feat, [layer.getStyle(), coChannelStyle]);
  }

  selectProcedureOnMap(feat: Feature, layer: VectorLayerDMTR) {

    const procedureSelectedStyle = new Style({
      fill: new Fill({ color: '#ffea00' }),
      stroke: new Stroke({ color: '#ffea00', width: 2 })
    });

    this.setSelectedFeature(layer, feat, [layer.getStyle(), procedureSelectedStyle]);
  }

  selectAirspaceBoundarynMap(feat: Feature, layer: VectorLayerDMTR) {

    const airspaceBoundarySelectedStyle = new Style({
      fill: new Fill({ color: '#ffea00' }),
      stroke: new Stroke({ color: '#ffea00', width: 2 })
    });

    this.setSelectedFeature(layer, feat, [layer.getStyle(), airspaceBoundarySelectedStyle]);
  }


highlightNavaidLocation(navaid: NavaidModel): Feature {
   const coordinate = olProj.fromLonLat(
    [navaid.longitude, navaid.latitude],
    this.mapService.getMaps().getView().getProjection()
  );

  const highlightFeature = new Feature(new Point(coordinate));
  highlightFeature.set('mapSearchHighlight', true);

  highlightFeature.setStyle(
    new Style({
      image: new CircleStyle({
        radius: 2,
        stroke: new Stroke({ color: 'rgba(255, 0, 0, 1)', width: 1 }),
        fill: new Fill({ color: 'rgba(255, 0, 0, 1)' }),
      }),
      zIndex: 99999,
    })
  );

  mapSearchHighlightLayer.olLayer.setVisible(true);
  mapSearchHighlightLayer.olLayer.setZIndex(99999);
  mapSearchHighlightLayer.olLayer.getSource().clear();
  mapSearchHighlightLayer.olLayer.getSource().addFeature(highlightFeature);

  return highlightFeature;
}

clearMapSearchHighlight(feat?: Feature): void {
  const source = mapSearchHighlightLayer.olLayer.getSource();
  source.clear();
  mapSearchHighlightLayer.olLayer.setVisible(false);
}


highlightCoordinatePointLocation(point: CoordinatePointModel): Feature {
  const coordinate = olProj.fromLonLat(
    [point.longitude, point.latitude],
    this.mapService.getMaps().getView().getProjection()
  );

  const highlightFeature = new Feature(new Point(coordinate));
  highlightFeature.set('mapSearchHighlight', true);

  highlightFeature.setStyle(
    new Style({
      image: new CircleStyle({
        radius: 2,
        stroke: new Stroke({
          color: 'rgba(255, 0, 0, 1)',
          width: 1,
        }),
        fill: new Fill({
          color: 'rgba(255, 0, 0, 1)',
        }),
      }),
      zIndex: 9988,
    })
  );

  mapSearchHighlightLayer.olLayer.setVisible(true);
  mapSearchHighlightLayer.olLayer.setZIndex(9999);
  mapSearchHighlightLayer.olLayer.getSource().clear();
  mapSearchHighlightLayer.olLayer.getSource().addFeature(highlightFeature);

  return highlightFeature;
}
}
